import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { FadeContainer } from "../Hocs/withFade";
import HelpIcon from "../Icons/HelpIcon";

const Container = styled.span<{ showChildren: boolean }>`
  pointer-events: none;
  display: flex;
  align-items: center;
  border-radius: 0.8em;
  position: absolute;
  ${({ showChildren }) =>
    showChildren ? "background: black;" : "background: unset;"}
`;
const Help = ({ children }: { children: React.ReactNode }) => {
  const [showChildren, setShowChildren] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    const handler = (event: MouseEvent) => {
      if (event.target && !ref.current?.contains(event.target as Node)) {
        setShowChildren(false);
      }
    };
    window.addEventListener("click", handler);
    return () => window.removeEventListener("click", handler);
  }, []);
  return (
    <Container ref={ref} showChildren={showChildren}>
      <>
        <FadeContainer show={showChildren}>{children}</FadeContainer>
        <HelpIcon onClick={() => setShowChildren((showing) => !showing)} />
      </>
    </Container>
  );
};

export default Help;
